import {
  PlaycastMessageSender,
  PlaycastIpcMessagingConfigurationOptions,
  PlaycastMessageReceiver,
  PlaycastMessage,
  PlaycastMessageTarget,
  validators,
  isSensitiveMessage,
} from '@playcastdotio/Messaging';

type Send = PlaycastMessageSender<PlaycastIpcMessagingConfigurationOptions>;
const sender: Send = {
  send: (options, message) => {
    if (window.playcast) {
      window.playcast?.ipc.send(options.channel, message);
    } else {
      console.error('[IPC-Protocol] Attempted to send ipc message from non electron environment.');
    }
  },
};

type Receive = PlaycastMessageReceiver<PlaycastIpcMessagingConfigurationOptions>;
const reciever: Receive = {
  receive: (options, callback) => {
    window.playcast?.ipc.on(options.channel, (message) => {
      const validatedMessage = validators.validatePlaycastMessage(message);
      if (!validatedMessage) {
        console.error('[IPC-Protocol] Invalid message received from main process');
        return;
      }
      callback(validatedMessage);
    });
  },
};

export const ipcSend = (message: PlaycastMessage<PlaycastMessageTarget>) => {
  const body = message.body.message as Record<string, unknown> | undefined;
  const payload =
    isSensitiveMessage(message)
      ? '[private message]'
      : body && typeof body === 'object' && typeof body.uploadUrl === 'string'
        ? { ...body, uploadUrl: redactPresignedUrl(body.uploadUrl) }
        : body;
  console.log('[IPC-Send] 📤 Sending message to Electron:', {
    target: message.header.target,
    type: message.header.action,
    hasPayload: !!message.body.message,
    payload,
  });
  sender.send({ channel: 'rendererMessage' }, message);
};

/** Presigned signatures live in the query string — never log them. */
function redactPresignedUrl(rawUrl: string): string {
  try {
    const url = new URL(rawUrl);
    return `${url.origin}${url.pathname}`;
  } catch {
    return '[invalid-url]';
  }
}

export const ipcReceive = (callback: (message: PlaycastMessage<PlaycastMessageTarget>) => void) => {
  reciever.receive({ channel: 'mainMessage' }, callback);
};
